import { useEffect, useState } from "react";
import { TSP_MAP_CONFIG } from "../../constants/tspMapConfig";

// The Survey of India map data (public/tsp/geo): the clickable state outlines
// and India's national boundary. Fetched once per page load and shared; null
// until loaded — and if a file cannot be loaded the map still works (states
// stay selectable from the list beside it).
const cache = new Map();

export function loadGeo(url) {
  if (typeof fetch !== "function") return Promise.resolve(null);
  if (!cache.has(url)) {
    cache.set(
      url,
      fetch(url)
        .then((res) => (res.ok ? res.json() : null))
        .catch(() => null)
        .then((data) => {
          if (!data) cache.delete(url); // try again next time
          return data;
        })
    );
  }
  return cache.get(url);
}

// { states, national } — each a GeoJSON FeatureCollection or null.
export default function useTspStateBoundaries() {
  const [geo, setGeo] = useState({ states: null, national: null });
  useEffect(() => {
    let active = true;
    Promise.all([loadGeo(TSP_MAP_CONFIG.statesUrl), loadGeo(TSP_MAP_CONFIG.nationalBoundaryUrl)]).then(([states, national]) => {
      if (active) setGeo({ states, national });
    });
    return () => {
      active = false;
    };
  }, []);
  return geo;
}
